import * as React from 'react';

import {Badge} from '../../badge/badge';
import {FileUploadButton} from '../../button/file-upload-button/file-upload-button';
import {colors} from '../../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {CloseIcon} from '../../icon/svg/close-icon';
import type {SalesDocumentType} from '../../lead-sidebar/sales-documents/types';
import {Body} from '../../typography/body';

import {handleFileUpload} from './helpers';
import {QuoteTextArea} from './quote-text-area';

import styles from './quote-header-editable.module.css';

type Props = {
    type: SalesDocumentType;
    leftSection: string;
    setLeftSection: (arg1: string) => void;
    rightSection: string;
    setRightSection: (arg1: string) => void;
    logo: string | null;
    setLogo: (arg1: string | null) => void;
};

export function QuoteHeaderEditable(props: Props) {
    return (
        <div className='flex justify-sb background-offwhite full-height full-width pad-16 border-box'>
            <div className={styles['input-container']}>
                <div className={styles['logo-container']}>
                    <div className='mb-4'>
                        <Body>Logo</Body>
                    </div>
                    <div className='flex flex-dir-col gap-8'>
                        {props.logo && (
                            <>
                                <div className={styles.image}>
                                    <Badge
                                        contents={
                                            <CloseIcon
                                                size={8}
                                                fill={colors.white}
                                                wrapWithDiv={false}
                                            />
                                        }
                                        onClick={() => {
                                            props.setLogo(null);
                                        }}
                                        color='grey'
                                    />
                                    <img src={props.logo} alt='logo' />
                                </div>
                            </>
                        )}
                        <FileUploadButton
                            id='logo'
                            name='logo'
                            accept='image/*'
                            showIcon={false}
                            text='Upload image'
                            shortButton={true}
                            whiteBackground={true}
                            onClick={() => {
                                handleFileUpload(props.setLogo);
                            }}
                        />
                    </div>
                </div>
                <div className={styles['text-container']}>
                    <div className={styles['text-input']}>
                        <div className='mb-4'>
                            <Body>Company + address</Body>
                        </div>
                        <div className='border-box border-dk br-3 full-height'>
                            <QuoteTextArea
                                value={props.leftSection}
                                onChange={props.setLeftSection}
                                showToolbar={false}
                                largerText={true}
                                padding={8}
                                backgroundColor='white'
                            />
                        </div>
                    </div>
                    <div className={styles['text-input']}>
                        <div className='mb-4'>
                            <Body>URL + phone</Body>
                        </div>
                        <div className='border-box border-dk br-3 full-height'>
                            <QuoteTextArea
                                value={props.rightSection}
                                onChange={props.setRightSection}
                                showToolbar={false}
                                largerText={true}
                                padding={8}
                                backgroundColor='white'
                                autoFocus={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles['label-container']}>
                <Body color='dark' size='xlarge' isBold={true}>
                    {props.type === 'Quote' ? 'QUOTE' : 'INVOICE'}
                </Body>
            </div>
        </div>
    );
}
